import React from "react";

import { inject, observer } from "mobx-react";

import { PermissionsController } from "../../PermissionsController";
import { Badge, Button, Divider, Tag } from "antd";
import { PermissionSearch } from "./PermissionSearch";
import _ from "lodash";
import dayjs from "dayjs";

@inject("permissionsController")
@observer
export class PanelControls extends React.Component<
  React.PropsWithChildren<{
    permissionsController?: PermissionsController;
  }>
> {
  private getTotalRoles = () => {
    const { selectedUserRole } = this.props.permissionsController;

    const values = {
      totals: selectedUserRole.permissions.length,
      past: 0,
      current: 0,
      future: 0,
    };

    selectedUserRole.permissions.forEach((p) => {
      values.past += p.past ? 1 : 0;
      values.current += p.current ? 1 : 0;
      values.future += p.future ? 1 : 0;
    });

    return values;
  };

  private renderAdditionalInfo = () => {
    const { selectedUserRole } = this.props.permissionsController;

    if (selectedUserRole?.updatedBy) {
      return (
        <>
          <Divider type="vertical" style={{ marginLeft: 0, marginRight: 6, width: 1, height: 25 }} />

          <span>{"Updated By"}&nbsp;</span>
          <span style={{ color: "#00000040" }}>{selectedUserRole.updatedBy}</span>

          <span>&nbsp;{"at"}&nbsp;</span>
          <span style={{ color: "#00000040" }}>{dayjs(selectedUserRole.updatedAt).format("DD/MM/YYYY HH:mm")}</span>
        </>
      );
    } else if (!selectedUserRole?.updatedBy && selectedUserRole?.updatedAt) {
      return (
        <>
          <Divider type="vertical" style={{ marginLeft: 0, marginRight: 6, width: 1, height: 25 }} />

          <span>&nbsp;{"Updated At"}&nbsp;</span>
          <span style={{ color: "#00000040" }}>{dayjs(selectedUserRole.updatedAt).format("DD/MM/YYYY HH:mm")}</span>
        </>
      );
    }
  };

  public render() {
    const { handleUserRoleSelection, validation, selectedUserRole, saveRolePermissions } = this.props.permissionsController;

    const total = this.getTotalRoles();

    return (
      <>
        <PermissionSearch />

        {this.props.children}

        <div
          style={{
            padding: 10,
            borderTop: "1px solid #ddd",
            background: "#fff",
            display: "flex",
            alignItems: "center",
          }}
        >
          <div className="flex-1">
            <span className="mr-3">
              <b className="mr-2">Total:</b>
              <Badge dot={selectedUserRole.mismatchedData}>
                <Tag style={{ margin: 0 }}>{total.totals}</Tag>
              </Badge>
            </span>
            {/* <span className="mr-3">
              <b className="mr-2">Past:</b>
              <Tag style={{ margin: 0 }}>{total.past}</Tag>
            </span> */}
            <span className="mr-3">
              <b className="mr-2">Enabled:</b>
              <Tag style={{ margin: 0 }}>{total.current}</Tag>
            </span>
            {/* <span className="mr-3">
              <b className="mr-2">Future:</b>
              <Tag style={{ margin: 0 }}>{total.future}</Tag>
            </span> */}

            {this.renderAdditionalInfo()}
          </div>
          <Button
            disabled={!validation("equal")}
            loading={!validation("page")}
            onClick={() => {
              handleUserRoleSelection(selectedUserRole._id);
            }}
            danger
            style={{ marginRight: 10 }}
          >
            Reset Changes
          </Button>

          <Button loading={!validation("page")} type="primary" onClick={() => saveRolePermissions(selectedUserRole)}>
            Save Changes
          </Button>
        </div>
      </>
    );
  }
}
